module.exports = __webpack_public_path__ + "img/edit-gray.cebfadf1.svg";